import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register('/service-worker.js', {
    ready() {},
    cached() {},
    updated() {},
    offline() {},
    error() {},
  });
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js